module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/cards-8e1336da5686414cbe62fcf3b14d21d1.png";